module.exports = __webpack_public_path__ + "assets/10bis-295e6a.svg";